import React, { useState, useEffect, useRef } from 'react';
import { DateRangePicker, createStaticRanges, defaultStaticRanges } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // Import the styles for the DateRange component
import 'react-date-range/dist/theme/default.css';
import moment from "moment";
import '../../assets/styles/DashboardStyling.css'
import { useRecoilValue, useSetRecoilState } from 'recoil';
import SecondaryButton from '../../../../../components/generic/buttons/SecondaryButton';
import { startOfQuarter, endOfQuarter } from "date-fns";
import { getLocalTimeZoneDateFormat } from '../../../../../utils/dateutils';
import { addDateFilterRecoil, defaultDateRangeRecoil } from '../../../../../components/recoil/dateRangeRecoil';
import SmartIcon from '../../../../../components/generic/genericIcon/SmartIcon';

const DateRangePickerComponent = ({ setIsDefaultDateRange, setDateRange, dateRange, showResetBtn, setShowResetBtn, filterRange = [] }) => {
    const [showDatePicker, setShowDatePicker] = useState(false)
    const datePickerRef = useRef(null);
    const buttonRef = useRef(null);
    const defaultDateRange = useRecoilValue(defaultDateRangeRecoil);
    const setAddDateFilter = useSetRecoilState(addDateFilterRecoil);

    const rootStyles = getComputedStyle(document.documentElement);
    const mainThemeColor = rootStyles.getPropertyValue('--main-theme-color').trim();

    const handleClickOutside = (event) => {
        if (
            datePickerRef.current &&
            !datePickerRef.current.contains(event.target) &&
            buttonRef.current &&
            !buttonRef.current.contains(event.target)
        ) {
            setShowDatePicker(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const dateFormat = getLocalTimeZoneDateFormat()

    const momentFormatStartDate = moment(dateRange?.[0]?.startDate).format(dateFormat);
    const momentFormatEndDate = moment(dateRange?.[0]?.endDate).format(dateFormat);

    const handleDateChange = (ranges) => {
        setDateRange([ranges.selection]);
        setIsDefaultDateRange(false)
        setShowResetBtn(true)
        setAddDateFilter(true)
    };

    const handleToggleDatePicker = () => {
        setShowDatePicker(!showDatePicker);
    };

    const handleResetDateRange = () => {
        setDateRange(defaultDateRange);
        setIsDefaultDateRange(true)
        setShowResetBtn(false)
        setAddDateFilter(false)
    };

    const staticRanges = createStaticRanges([
        ...defaultStaticRanges.filter(
            (range) => !filterRange.includes(range.label)
        ),
        {
            label: "This Quarter",
            range: () => ({
                startDate: startOfQuarter(new Date()),
                endDate: endOfQuarter(new Date())
            })
        }
    ]);

    return (
        <div>
            <div className='d-flex justify-content-between align-items-center' style={{ columnGap: "0.5rem" }}>
                <div className='dateStyling dashboard-dates'>
                    <span>{momentFormatStartDate}</span>
                    <span className='text-center'> to </span>
                    <span>{momentFormatEndDate}</span>
                </div>
                <div ref={buttonRef} onClick={handleToggleDatePicker} style={{ cursor: "pointer" }}>{showDatePicker ? <SmartIcon iconKey={"colorCalendar"} /> : <SmartIcon iconKey={"darkCalendar"} />}</div>
                {
                    showResetBtn &&
                    <SecondaryButton buttonText={"Reset"} handleOnClick={handleResetDateRange} />
                }
            </div>

            {showDatePicker && (
                <div className="date-picker-container" ref={datePickerRef} style={{ position: 'absolute', zIndex: '9999', top: '3rem', display: 'flex', justifyContent: 'end', right: '30px' }}>
                    <DateRangePicker
                        ranges={dateRange}
                        onChange={handleDateChange}
                        color={mainThemeColor}
                        rangeColors={[mainThemeColor]}
                        staticRanges={staticRanges}
                    />
                </div>
            )}
        </div>
    )
}

export default DateRangePickerComponent